import React from 'react';
import { createAlert } from './Alert';
import { StyledAlert } from './Alert.styled';
import { StyledBanner, StyledBannerInlineAlert, StyledInlineAlert } from './InlineAlert.styled';
var createInlineAlert = function createInlineAlert(alertType) {
  var StyledAlertType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : StyledInlineAlert;
  return function (props) {
    var Alert = createAlert(alertType, props.action ? StyledAlert : StyledAlertType);
    return /*#__PURE__*/React.createElement(Alert, props);
  };
};
function createBanner(alertType) {
  var Alert = createInlineAlert(alertType, StyledBannerInlineAlert);
  var AlertBanner = function AlertBanner(props) {
    return /*#__PURE__*/React.createElement(StyledBanner, null, /*#__PURE__*/React.createElement(Alert, props));
  };
  return AlertBanner;
}
export var WarningAlert = createInlineAlert('Warning');
export var ErrorAlert = createInlineAlert('Error');
export var InfoAlert = createInlineAlert('Info');
export var SuccessAlert = createInlineAlert('Success');
export var WarningBanner = createBanner('Warning');
export var ErrorBanner = createBanner('Error');
export var InfoBanner = createBanner('Info');
export var SuccessBanner = createBanner('Success');